import { httpClient } from '@/services/http/httpClient'

import type { IdeaFeedParameters } from '../types'

type IdeaFeedParamsHttpResponse = {
  [key in IdeaFeedParameters]?: string
}

type IdeaFeedParams = {
  [key in IdeaFeedParameters]: boolean
}

export async function getIdeaFeedParams(): Promise<IdeaFeedParams> {
  const { data } = await httpClient.get<IdeaFeedParamsHttpResponse>(
    '/tennants/configs/idea-feed',
  )

  return {
    allIdeas: data?.allIdeas === 'true',
    ownIdeas: data?.ownIdeas === 'true',
    allUsersIdeas: data?.allUsersIdeas === 'true',
    unReviewedIdeas: data?.unReviewedIdeas === 'true',
    reviewedIdeas: data?.reviewedIdeas === 'true',
    rejectedIdeas: data?.rejectedIdeas === 'true',
    activeChallengesIdeas: data?.activeChallengesIdeas === 'true',
  }
}
